import {Component, Input, OnChanges} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {FolderService} from '../../../services/folder/folder.service';
import {AuthService} from '../../../services/auth/auth.service';
import {FolderItemType, FolderUsage} from '../../../dtos/folder/folder';
import {folderUsageText} from '../../../shared/folder/folder-utils';

/**
 * admin only: shows in how many Sammelmappen an entry is contained, e.g. in the edit dialogs.
 * Information only, nothing is shown if the entry is in no list or the request fails.
 */
@Component({
  selector: 'app-folder-usage-hint',
  templateUrl: './folder-usage-hint.component.html',
  styleUrls: ['./folder-usage-hint.component.scss'],
  imports: [MatIconModule],
  standalone: true
})
export class FolderUsageHintComponent implements OnChanges {

  @Input() type: FolderItemType;
  @Input() entryId: number;

  usage: FolderUsage;

  constructor(private folderService: FolderService, private authService: AuthService) {
  }

  ngOnChanges(): void {
    this.usage = null;
    if (this.type && this.entryId != null && this.authService.getUserRole() === 'ROLE_ADMIN') {
      this.folderService.getUsage(this.type, this.entryId).subscribe({
        next: usage => this.usage = usage,
        error: () => this.usage = null
      });
    }
  }

  usageText(usage: FolderUsage): string {
    return folderUsageText(usage);
  }
}
